import { render } from "./JoinUs.vue?vue&type=template&id=4fa86baa&scoped=true"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"

import "./JoinUs.vue?vue&type=style&index=0&id=4fa86baa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fa86baa"

export default script